<nz-modal
  [(nzVisible)]="isShowLogin"
  nzCentered
  (nzOnCancel)="handleCancel()"
  (nzOnOk)="handleOk()"
  nzWrapClassName="login-modal"
  nzKeyboard="false"
  nzWidth="600px"
  >
  <ng-container *nzModalContent>
    <div class="content-holder">
      @if (!forgotPassword) {
        <h1>Login</h1>
        <p>Find the career you always wanted.</p>
        <mat-form-field class="block-input">
          <mat-label>Email address</mat-label>
          <input matInput placeholder="Email address" />
        </mat-form-field>
        <mat-form-field class="block-input">
          <mat-label>Password</mat-label>
          <input
            matInput
            placeholder="Password"
            [type]="showPassword ? 'text' : 'password'"
            />
            <div
              matSuffix
              (click)="showPassword = !showPassword"
              style="margin-right: 10px; cursor: pointer"
              >
              @if (showPassword) {
                <i class="fa-regular fa-eye"></i>
              }
              @if (!showPassword) {
                <i class="fa-regular fa-eye-slash"></i>
              }
            </div>
          </mat-form-field>
          <div class="stay-forgot">
            <div>
              <nz-switch [(ngModel)]="staySignedIn" nzSize="small" />
              <label (click)="staySignedIn = !staySignedIn">Stay signed in</label>
            </div>
            <a (click)="showForgotPassword()">Forgot password?</a>
          </div>
          <button (click)="logout()">logout</button>
          <button
            nz-button
            class="btn-next"
            nzType="primary"
            nzSize="large"
            nzShape="round"
            (click)="login()"
            >
            Login
          </button>
          <div class="login-divider">
            <span>or</span>
          </div>
          <div class="social-login">
            <a>
              <img src="assets/images/google.png" alt="google" />
              <span>Login with Google</span>
            </a>
          </div>
          <div class="create-account">
            <span>Don’t have an account yet?</span>
            <a (click)="showRegistration()">Create your account</a>
          </div>
        }
        @if (forgotPassword) {
          <h1>Reset Password</h1>
          <p>
            Please enter your email address and we'll send you a link to reset
            your password.
          </p>
          <mat-form-field class="block-input">
            <mat-label>Email address</mat-label>
            <input matInput placeholder="Email address" />
          </mat-form-field>
          <button
            nz-button
            class="btn-next"
            nzType="primary"
            nzSize="large"
            nzShape="round"
            >
            Submit
          </button>
          <div class="create-account">
            <span>Go back to</span>
            <a (click)="showForgotPassword()">Login page.</a>
          </div>
        }
      </div>
    </ng-container>
    <div *nzModalFooter></div>
  </nz-modal>
